/**
 * localStorage com prefixo por unidade (multi-tenant no cliente).
 */
export function storageKey(baseKey, unidadeCodigo) {
  if (!unidadeCodigo) return baseKey;
  return `${baseKey}__${unidadeCodigo}`;
}

export function getUnitStorage(baseKey, unidadeCodigo, fallback = null) {
  const key = storageKey(baseKey, unidadeCodigo);
  const raw = localStorage.getItem(key);
  if (raw != null) return raw;
  if (!unidadeCodigo) return fallback;
  const legacy = localStorage.getItem(baseKey);
  return legacy != null ? legacy : fallback;
}

export function getUnitStorageJSON(baseKey, unidadeCodigo, fallback = null) {
  const raw = getUnitStorage(baseKey, unidadeCodigo, null);
  if (raw == null) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function setUnitStorageJSON(baseKey, unidadeCodigo, value) {
  localStorage.setItem(storageKey(baseKey, unidadeCodigo), JSON.stringify(value));
}

export function withUnidade(path, unidade) {
  if (!unidade?.codigo) return path;
  return path.includes('?')
    ? `${path}&unidade=${encodeURIComponent(unidade.codigo)}`
    : `${path}?unidade=${encodeURIComponent(unidade.codigo)}`;
}
